export default "__VITE_ASSET__CttrkzPT__"